import { NewDateTimeFormat } from '../../Functions';
export function CargoTransferSlipHeaDCompose(page, rowL, cts, dataUrl) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    var imageX = 140;
    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 50, 18);

    _y += _space * 2;

    return _y;
}

export function CargoTransferSlipHeadingCompose(page, rowL, cts, data) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    let current_datetime = new Date()
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes();

    doc.setFont("times", "bold");
    doc.text('CARGO TRANSFER SLIP', 110, _y, null, null, 'center');
    doc.setFont("times", "normal");

    _y += _space * 2;
    doc.setFont("times", "bold");
    doc.text(20, _y, 'Date Printed:');
    doc.setFont("times", "normal");
    doc.text(55, _y, formatted_date);

    doc.setFont("times", "bold");
    doc.text(130, _y, 'Branch:');
    doc.setFont("times", "normal");
    doc.text(150, _y, data.branchName ? data.branchName : '');

    _y += _space;

    return _y;
}

export function CargoTransferSlipContentCompose(page, rowL, cts, data) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    // console.log('data', data);
    if(data.header.hustlingCstNum){
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Control No:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data.header.hustlingCstNum ? data.header.hustlingCstNum : '');
        _y += _space * 2;
    }
    else {
        _y += _space;
    }
    // doc.setFont("times", "bold");
    // doc.text(20, _y, 'Trucker:');
    // doc.setFont("times", "normal");
    // doc.text(50, _y, data.header.truckerName ? data.header.truckerName : '');
    // doc.line(50, _y + 1, 195, _y + 1);

    // _y += _space * 2;

    if(data.header.hustVoyageNum || data.header.voyageNum){
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Voyage Ref');
        doc.setFont("times", "normal");
        doc.text(50, _y, data.header.voyageRef ? data.header.voyageRef : '');
        doc.line(50, _y + 1, 100, _y + 1);
        _y += _space;
        
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Voyage');
        doc.setFont("times", "normal");
        doc.text(50, _y, data.header.hustVoyageNum ? data.header.hustVoyageNum : data.header.voyageNum ? data.header.voyageNum : '');
        doc.line(50, _y + 1, 100, _y + 1);

        if(data.header.hustVessel || data.header.tovesselName){
            doc.setFont("times", "bold");
            doc.text(110, _y, 'Vessel');
            doc.setFont("times", "normal");
            doc.text(143, _y, data.header.hustVessel ? data.header.hustVessel : data.header.tovesselName ? data.header.tovesselName : '');
            doc.line(143, _y + 1, 195, _y + 1);
            _y += _space;
        } else {
            _y += _space;
        }
    }

    doc.setFont("times", "bold");
    doc.text(20, _y, 'Date Started');
    doc.setFont("times", "normal");
    doc.text(50, _y, data.header.dateTimeIn ? NewDateTimeFormat(data.header.dateTimeIn) : '');
    doc.line(50, _y + 1, 100, _y + 1);
    
    doc.setFont("times", "bold");
    doc.text(110, _y, 'Date Finished');
    doc.setFont("times", "normal");
    doc.text(143, _y, data.header.dateTimeOut ? NewDateTimeFormat(data.header.dateTimeOut) : '');
    doc.line(143, _y + 1, 195, _y + 1);
    _y += _space;

    doc.setFont("times", "bold");
    doc.text(20, _y, 'From');
    doc.setFont("times", "normal");
    doc.text(50, _y, data.header.fromCyName ? data.header.fromCyName : '');
    doc.line(50, _y + 1, 100, _y + 1);

    doc.setFont("times", "bold");
    doc.text(110, _y, 'To');
    doc.setFont("times", "normal");
    let ToValue = '';

    if(data.header.toReference === 'To Vessel'){
        ToValue = data.header.hustVessel ? data.header.hustVessel : data.header.tovesselName;
    } else if(data.header.toReference === 'To Port'){
        ToValue = data.header.toPortName;
    } else {
        ToValue = data.header.toCyName ? data.header.toCyName : '';
    }
    doc.text(143, _y, ToValue);
    doc.line(143, _y + 1, 195, _y + 1);

    _y += _space * 2;
    doc.setFont("times", "bold");
    doc.text(20, _y, 'Container #');
    doc.text(55, _y, 'Type');
    doc.text(70, _y, 'Plate #');
    doc.text(100, _y, 'Driver');
    doc.text(146, _y, 'Size');
    doc.text(160, _y, 'Remarks');
    doc.setFont("times", "normal");
    doc.line(20, _y + 1, 195, _y + 1);
    _y += _space;
    data.container.forEach(van => {
        doc.text(20, _y, van.containerVanNum ? van.containerVanNum : '');
        doc.text(55, _y, van.containerType ? van.containerType : '');
        doc.text(70, _y, van.plateNum ? van.plateNum : '');
        doc.text(100, _y, van.driver ? van.driver : '');
        doc.text(146, _y, van.size ? van.size : '');
        doc.text(160, _y, van.detailsRemarks ? van.detailsRemarks : '');
        doc.line(20, _y + 1, 195, _y + 1);
        _y += _space;
    });

    _y += _space * 2;

    doc.setFont("times", "bold");
    doc.text(20, _y, 'Remarks');
    doc.setFont("times", "normal");
    doc.text(40, _y, data.header.remarks ? data.header.remarks : '');
    doc.line(40, _y + 1, 195, _y + 1);

    _y += _space * 2;

    return _y;
}

export function CargoTransferSlipClosingCompose(page, rowL, cts, user) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space * 2;

    doc.text(20, _y, 'Issued By:');
    doc.text(45, _y, user.name ? user.name : '');
    doc.line(45, _y + 1, 95, _y + 1);

    doc.text(100, _y, 'Received By:');
    doc.line(130, _y + 1, 190, _y + 1);
    _y += _space * 1.2;
    doc.text(128, _y, 'Signature over Printed Name');

    _y += _space * 2;
    return _y;
}